import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getConfig } from "plugins/config-loader";
const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: getConfig("REACT_APP_PACING_BACKEND_BASE_URL"),
        prepareHeaders: (headers, { getState, extra }) => {
            const state = getState();
            const token = extra.getStateValue(state, "accessToken");
            const connectionId = extra.getStateValue(state, "connectionId");
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            if (connectionId) {
                headers.set("Connection-Id", connectionId);
            }
            return headers;
        }
    }),
    endpoints: (builder) => ({
        calculateObjective: builder.mutation({
            query: (request) => ({
                body: request,
                method: "POST",
                url: "calculate"
            })
        }),
        createObjective: builder.mutation({
            invalidatesTags: ["Objectives"],
            query: (request) => ({
                body: request.objective,
                method: "POST",
                params: request.id ? { objectiveId: request.id } : undefined,
                url: "objectives"
            })
        }),
        deleteObjective: builder.mutation({
            invalidatesTags: ["Objectives"],
            query: (request) => ({
                method: "DELETE",
                url: `objectives/${request.name}`
            })
        }),
        listAllObjectives: builder.query({
            providesTags: ["Objectives"],
            query: () => ({
                method: "GET",
                url: "objectives"
            }),
            transformResponse: (result) => result.objectives
        }),
        listCashflowModels: builder.query({
            forceRefetch: () => true,
            providesTags: ["CashflowModels"],
            query: () => "cashflow-models",
            transformResponse: (result) => result.cashflowModels
        }),
        listGeographies: builder.query({
            providesTags: ["Geographies"],
            query: () => "geographies",
            transformResponse: (result) => result.geographies
        }),
        listObjectives: builder.query({
            providesTags: (_, __, arg) => ["Objectives", { id: arg.portfolioId, type: "Objectives" }],
            query: (request) => ({
                method: "GET",
                url: `objectives?filter=portfolio_id = "${request.portfolioId}"`
            }),
            transformResponse: (result) => result.objectives
        }),
        listSectorFocuses: builder.query({
            providesTags: ["SectorFocuses"],
            query: () => "sector-focuses",
            transformResponse: (result) => result.sectorFocuses
        }),
        listStrategies: builder.query({
            providesTags: ["Strategies"],
            query: () => "strategies",
            transformResponse: (result) => result.strategies
        }),
        listTargetAllocationDropdownValues: builder.query({
            forceRefetch: () => true,
            providesTags: ["TargetAllocationDropdownValues"],
            query: () => "target-nav-allocation-dropdown-values"
        }),
        updateObjective: builder.mutation({
            invalidatesTags: ["Objectives"],
            query: (request) => ({
                body: request.objective,
                method: "PUT",
                url: `objectives/${request.id}`
            })
        })
    }),
    reducerPath: "commitmentPacingApi",
    tagTypes: ["Objectives", "CashflowModels", "Geographies", "SectorFocuses", "Strategies", "TargetAllocationDropdownValues"]
});
export const { useListObjectivesQuery, useListAllObjectivesQuery, useCreateObjectiveMutation, useDeleteObjectiveMutation, useUpdateObjectiveMutation, useCalculateObjectiveMutation, useListCashflowModelsQuery, useListTargetAllocationDropdownValuesQuery, useListGeographiesQuery, useListStrategiesQuery, useListSectorFocusesQuery, middleware: commitmentPacingMiddleware, reducer: commitmentPacingReducers, reducerPath: commitmentPacingReducersPath } = api;
export const objectivesFetched = api.endpoints.listObjectives.matchFulfilled;
export const objectiveCreated = api.endpoints.createObjective.matchFulfilled;
export const objectiveUpdated = api.endpoints.updateObjective.matchFulfilled;
export const objectiveDeleted = api.endpoints.deleteObjective.matchFulfilled;
export const objectiveCreateFailed = api.endpoints.createObjective.matchRejected;
export const objectiveUpdateFailed = api.endpoints.updateObjective.matchRejected;
export const calculateOperationCreated = api.endpoints.calculateObjective.matchFulfilled;
export const calculateOperationFailed = api.endpoints.calculateObjective.matchRejected;
export const invalidatesObjectives = (portfolio) => api.util.invalidateTags([portfolio ? { id: portfolio, type: "Objectives" } : "Objectives"]);
